/** Roles that take or sign decisions. */
export const DECIDER_ROLES = ["Minister", "Undersecretary", "AssistantUndersecretary", "Director", "Admin"] as const;

/** Roles that supervise a section: they see what awaits decision, the workload and unassigned files. */
export const SUPERVISOR_ROLES = [...DECIDER_ROLES, "HeadOfComplaints"] as const;

export function hasAnyRole(roles: readonly string[] | undefined, wanted: readonly string[]): boolean {
  return !!roles && wanted.some((r) => roles.includes(r));
}
